import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';

const handleChange = (input, inputEventTarget, onChangeCallback) => {
    const file = inputEventTarget.files[0];
    if (file) {
        input.onChange({
            name: file.name,
        });
        const resetInputState = () => {
            // eslint-disable-next-line no-param-reassign
            inputEventTarget.value = null;
        };
        onChangeCallback(file, resetInputState);
    }
};

const GenericFileUploadField = ({ name, accept, onChangeCallback }) => (
    <Field name={name}>
        {/* eslint-disable-next-line no-unused-vars */}
        {({ input: { value, ...input }, meta }) => (
            <>
                <input
                    {...input}
                    className="appearance-none shadow-inner shadow-xl rounded w-full py-2 px-4 text-gray-700 leading-tight border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 bg-gray-200"
                    type="file"
                    accept={accept}
                    onChange={({ target }) => {
                        handleChange(input, target, onChangeCallback);
                    }}
                    data-testid={name}
                />
                {meta.error && meta.touched && (
                    <span
                        className="text-xs italic w-full text-red-700 font-semibold"
                        data-testid="file-upload-error-message"
                    >
                        {' '}
                        {meta.error}{' '}
                    </span>
                )}
            </>
        )}
    </Field>
);

GenericFileUploadField.propTypes = {
    name: PropTypes.string,
    accept: PropTypes.string,
    onChangeCallback: PropTypes.func,
};

export default GenericFileUploadField;
